let hasUnsavedChanges = false;

export const setUnsavedChanges = (value: boolean) => {
  hasUnsavedChanges = value;

  // optional event (if you want listeners later)
  window.dispatchEvent(
    new CustomEvent('unsavedChanges', { detail: value })
  );
};

export const getUnsavedChanges = () => hasUnsavedChanges;
